import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "bionet_cookie_consent";

export const hasCookieConsent = () => {
  try {
    return localStorage.getItem(COOKIE_KEY) === "accepted";
  } catch {
    return false;
  }
};

const CookieBanner = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(COOKIE_KEY);
      if (!v) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  const decide = (val) => {
    try {
      localStorage.setItem(COOKIE_KEY, val);
    } catch {
      /* ignore */
    }
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-5 sm:max-w-md z-50"
          data-testid="cookie-banner"
        >
          <div className="rounded-2xl bg-white border border-slate-200 shadow-xl p-5">
            <div className="flex items-start gap-3">
              <div className="h-9 w-9 rounded-full bg-emerald-50 flex items-center justify-center shrink-0">
                <Cookie className="h-5 w-5 text-brand-green" />
              </div>
              <div className="flex-1">
                <div className="font-heading font-bold text-slate-900">{t("cookies.title")}</div>
                <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                  {t("cookies.description")}{" "}
                  <Link to="/politique-confidentialite" className="text-brand-blue hover:underline">
                    {t("cookies.learn_more")}
                  </Link>
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  <button
                    onClick={() => decide("accepted")}
                    className="btn-primary !py-2 !px-4 text-sm"
                    data-testid="cookie-accept"
                  >
                    {t("cookies.accept")}
                  </button>
                  <button
                    onClick={() => decide("refused")}
                    className="btn-secondary !py-2 !px-4 text-sm"
                    data-testid="cookie-refuse"
                  >
                    {t("cookies.refuse")}
                  </button>
                </div>
              </div>
              <button
                onClick={() => decide("refused")}
                className="text-slate-400 hover:text-slate-700"
                aria-label="close"
                data-testid="cookie-close"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
